import { gql } from '@apollo/client'

export const ITINERARY_SEND_MUTATION = gql`
  mutation($input: SendItineraryInput!) {
    sendItinerary(input: $input) {
      success
    }
  }
`
